<template>
  <svg v-if="isFill" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5 0C7.5435 0 0 5.904 0 13.5C0 20.4495 6.33 25.9905 14.2425 26.8755C14.3788 26.8882 14.509 26.938 14.619 27.0195C14.694 27.0795 14.7225 27.1395 14.7285 27.207C14.8335 28.2645 14.6025 29.685 14.298 30.4845C14.255 30.5981 14.2402 30.7204 14.255 30.8409C14.2697 30.9614 14.3134 31.0766 14.3825 31.1765C14.4515 31.2764 14.5438 31.358 14.6514 31.4143C14.7589 31.4707 14.8786 31.5001 15 31.5C15.2115 31.5 15.45 31.437 15.6495 31.377C15.8715 31.308 16.137 31.2105 16.434 31.089C17.186 30.7726 17.9232 30.4222 18.6435 30.039C20.7327 28.9386 22.7288 27.6699 24.612 26.2455C26.712 24.651 28.797 22.7385 30.36 20.6025C31.92 18.468 33 16.0635 33 13.5C33 5.904 25.4565 0 16.5 0ZM4.875 9.75H7.125V15.375H10.5V17.625H4.875V9.75ZM11.625 9.75V17.625H13.875V9.75H11.625ZM14.625 9.75H17.175L19.125 13.407V9.75H21.375V17.625H18.825L16.875 13.968V17.625H14.625V9.75ZM22.125 9.75H27V12H24.375V12.5625H27V14.8125H24.375V15.375H27V17.625H22.125V9.75Z"
      fill="#2CCF54"
    />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path
      d="M7.49902 11.4507V18.5382H12.2133M14.5705 11.4507V19.3257M17.7133 19.3257V12.2382H18.499L21.6419 18.5382H22.4276V11.4507M29.499 12.2382H25.5705V18.5382H29.499M25.5705 15.3882H29.499"
      stroke="#171717"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M18.5 2C9.38729 2 2 7.99445 2 15.3875C2 22.1537 8.18829 27.7481 16.2214 28.649C16.8249 28.7167 17.367 29.0979 17.4267 29.7043C17.5493 30.9422 17.2853 32.555 16.9286 33.5C18.4183 33.5 35 25.2533 35 15.3875C35 7.99445 27.6127 2 18.5 2Z"
      stroke="#171717"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LineIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    isFill: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
